<!-- 文书 - 查看feedback -->
<template>
  <div>
    <zlr-modal v-model="isShow">
      <div class="look-feeedback">
        <h1 class="feedback-title">Feedback</h1>
        <p class="feedback-time">{{data.uploadTime}}</p>
        <div>
          <pre v-html="data.steer">{{data.steer}}</pre>
        </div>
        <div class="feedback-btn">
          <Button class="zlr-btn-default"
                  @click="handleColse">Close</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// components
import ZlrModal from '_c/modal/modal'
export default {
  name: 'program-essay-feedback',
  props: ['data'],
  components: {
    ZlrModal
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    getDetail () {

    },
    handleShow () {
      this.isShow = true
    },
    handleColse () {
      this.isShow = false
    }
  },
  watch: {
    isShow (newValue) {
      if (newValue) {
        this.getDetail()
      }
    }
  }
}
</script>
<style lang='less' scoped>
.look-feeedback {
  width: 960px;
  .feedback-title {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 36px;
    margin-bottom: 4px;
    font-weight: normal;
  }
  .feedback-time {
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
    margin-bottom: 24px;
  }
  .feedback-btn {
    margin-top: 40px;
    padding-bottom: 8px;
  }
}
</style>
